// Shared Tailwind class strings for raw form controls across the app, so
// every <input>/<select>/<textarea> gets the same dark, gold-focus-ring
// treatment as the production app's `.field input` styling, without every
// screen having to restate it.
export const fieldLabelClass = 'text-[11px] font-semibold uppercase tracking-wide text-slate-500';
export const fieldControlClass =
  'w-full rounded-lg border border-ink-border bg-ink px-3 py-2 text-sm text-white placeholder:text-slate-600 outline-none transition focus:border-gold-700 focus:ring-2 focus:ring-gold-900/60 disabled:opacity-50';
export const fieldControlSmClass =
  'w-full rounded-md border border-ink-border bg-ink px-2 py-1.5 text-sm text-white placeholder:text-slate-600 outline-none transition focus:border-gold-700 focus:ring-2 focus:ring-gold-900/60 disabled:opacity-50';
